import BackendApi from '../backendApi'
let backendApi = new BackendApi();


const projectMixin = {

    data() {
        return {
            projectId: null
        }
    },

    methods: {

    },

    mounted() {
        let vm = this;

        let selectedProjectId = localStorage.getItem('selectedProjectId');
        if (selectedProjectId != null) {
            vm.projectId = parseInt(selectedProjectId);
        }
    }
};

export default projectMixin;


// WEBPACK FOOTER //
// ./Content/src/helpers/project-mixin.js